// utility function to comepensate for lack of FormData support in Safari

function getEntries(form) {
  const { elements } = form;
  return Array.from(elements).reduce((arr, element) => {
    const { name } = element;
    if (!name) return arr;
    let { value } = element;
    if (element.files) {
      if (element.multiple === true) {
        value = element.files;
      } else {
        value = element.files[0];
      }
    }
    return [...arr, [name, value]];
  }, []);
}

export default function browserOptimize(form, formElm) {
  if (form.entries === undefined) {
    return getEntries(formElm);
  }
  return Array.from(form.entries());
}



// WEBPACK FOOTER //
// ./src/utils/browserOptimize.js